.loading-container {
  display: flex;
  align-items: center;
  padding: 30px 0;
  min-height: 500px;
  &--small-mt {
    align-items: flex-start;
    margin-top: 32px;
  }
  &--full-h {
    min-height: auto;
    height: 100%;
    padding: 0;
  }
}
.absoluteCenter {
  position: absolute;
  left: calc(50% - 36px);
  min-height: 300px;
  height: auto;
}
.loading {
  display: inline-block;
  position: relative;
  width: 72px;
  height: 72px;
  margin: 0 auto;
  div {
    position: absolute;
    border: 4px solid #b32442;
    opacity: 1;
    border-radius: 50%;
    animation: loading 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  div:nth-child(2) {
    animation-delay: -0.5s;
  }
}

@keyframes loading {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
